<template>
  <div class="modal-root">
    <div class="modal-header">
      <div class="modal-header-left-nav">
        <div v-if="prevButton" class="modal-go-back" @click="$emit('prev')">
          <img src="../../assets/common/arrow.svg" alt="Go Back" />
        </div>
      </div>
      <div class="modal-title" v-if="modalTitle">{{ modalTitle }}</div>
      <div class="modal-header-right-nav">
        <div v-if="closeButton" class="modal-close">
          <img
            class="cross"
            src="../../assets/common/close-icon.svg"
            @click="$emit('close')"
            alt="Leave"
          />
        </div>
      </div>
    </div>
    <div class="modal-content">
      <slot />
    </div>
  </div>
</template>

<script>
import scanScreen from '@/mixins/scan-screen';

export default {
  name: 'Modal',
  mixins: [scanScreen],
  props: {
    modalTitle: {
      type: String,
      default: '',
    },
    prevButton: {
      type: Boolean,
      default: false,
    },
    closeButton: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-root {
  @apply fixed top-0 left-0 w-full h-full bg-white flex-col w-full h-full flex flex-col items-center z-40;
  &.scrollable {
    @apply pb-0 overflow-y-auto;
    @screen tall {
      @apply pb-20 overflow-y-hidden;
    }
  }
}
.modal-header {
  @apply w-full flex flex-row items-center justify-between px-8 pt-16 pb-0;
}

.modal-title {
  @apply font-semibold text-xl;
}

.modal-content {
  @apply w-full flex flex-col flex-grow items-center justify-start px-6 py-8;
}

.modal-footer {
  @apply w-full flex flex-row justify-around px-8 pb-12 pt-0;
}

.modal-go-back {
  img {
    @apply transform -rotate-90;
  }
}

.screen-titles {
  @apply flex relative flex-col w-full text-left h-40 mt-16 px-8;
  @screen sm {
    @apply mt-20 px-20;
  }
  @screen md {
    @apply h-64;
  }
  @screen lg {
    @apply mt-24 px-24;
  }
  .error-icon {
    @apply absolute mx-auto;
    width: 5%;
    left: 0;
    right: 0;
    top: -15%;
  }
}
.screen-name {
  @apply text-2xl;
  font-weight: 500;
  line-height: 1.25;
  color: #5b5b5b;
  @screen xs {
    @apply text-lg;
  }
  @screen lg {
    @apply text-4xl;
  }
}
.step-wrapper {
  @apply flex flex-row mt-2;
  .screen-info {
    @apply text-left text-base font-semibold;
    line-height: 20px;
  }
}
.step {
  @apply text-xl text-center mt-5 mx-5;
  font-size: 70px;
  line-height: 60px;
}
.screen-info {
  @apply text-xl text-center mt-5;
  font-weight: bold;
  line-height: 1.5;
  color: #2c2c2c;
  min-height: 6rem;
  @screen sm {
    @apply text-4xl;
  }
  @screen lg {
    @apply text-5xl;
  }
  &.error {
    @apply font-bold;
    color: #b32223;
  }
}
.intro-text {
  @apply mx-auto text-center flex flex-1 flex-col justify-center overflow-visible w-full pt-10;
  font-size: 33px;
}
.content-container {
  @apply flex flex-1 flex-col items-center overflow-visible w-full px-6 py-4;
  @screen sm {
    @apply px-20;
  }
  @screen tall {
    @apply pt-8 pb-20;
  }
  &.no-padding {
    padding: 0 !important;
  }
}
.skip-btn {
  @apply absolute top-0 left-0 mt-10 ml-12 cursor-pointer;
  color: rgba(38, 38, 38, 0.4);

  @screen xs {
    @apply mt-4 ml-5;
    margin-top: calc(constant(safe-area-inset-top, -1rem) + 1rem);
    margin-top: calc(env(safe-area-inset-top, -1rem) + 1rem);
  }
}
.alt-info {
  @apply mb-32 text-center;
  font-size: 18px;
  max-width: 70%;
  @screen lg {
    @apply mb-56;
    font-size: 24px;
  }
}
</style>
